/* INVOICES */
export const GET_SCREEN_DETAILS = "GET_SCREEN_DETAILS"
export const GET_SCREEN_DETAILS_SUCCESS = "GET_SCREEN_DETAILS_SUCCESS"
export const GET_SCREEN_DETAILS_FAIL = "GET_SCREEN_DETAILS_FAIL"

export const UPDATE_SCREEN_DETAILS = "UPDATE_SCREEN_DETAILS"
export const UPDATE_SCREEN_DETAILS_SUCCESS = "UPDATE_SCREEN_DETAILS_SUCCESS"
export const UPDATE_SCREEN_DETAILS_FAIL = "UPDATE_SCREEN_DETAILS_FAIL"
